import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/KonzaWisdom";

const WisdomPhase2 = () => {
  const projectId = "PRJ00067";
  const title = "Wisdom Phase 2";

  const mapConfig = {
    minZoom: 9,
    zoom: 10,
    bounds: [
      [26.17, -176.68],
      [25.64, -175.84],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/plots-in-konza/wisdom-gardens-phase2-konza/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSdyBTTaYC4tkjD6oQyTFalLXinukIeDisvE4P98m0Al-qV1iA/viewform"
    />
  );
};

export default WisdomPhase2;
